// New-message notifications on every signed-in page: flips the nav bell and,
// when the conversations page is open, updates the matching list row.
$(document).ready(function() {
  const bell = document.getElementById('notify-bell');
  if (!bell || !window.App || !App.cable) return;

  App.cable.subscriptions.create({ channel: 'NotificationsChannel' }, {
    received(data) {
      // Sent once on subscribe: the unread state as of now, which covers a
      // message that arrived between this page rendering and subscribing.
      if (data.type === 'state') {
        if (data.unread_conversations_count > 0) markBellUnread();
        return;
      }

      const page = document.getElementById('cv-thread-page');
      const isOpenThread = page && page.dataset.conversationId === data.conversation_slug;

      // The open thread appends the message itself and marks it read.
      if (!isOpenThread) markBellUnread();
      if (page) updateConversationRow(data, isOpenThread);
    }
  });

  function markBellUnread() {
    const svg = bell.querySelector('svg');
    svg.setAttribute('fill', 'url(#grad1)');
    svg.setAttribute('stroke', 'orange');
    bell.dataset.unread = '1';

    const text = document.getElementById('notify-text');
    if (text) text.textContent = 'You have new messages!';
  }

  function updateConversationRow(data, isOpenThread) {
    const rows = document.querySelector('.cv-rows');
    const row = rows && rows.querySelector('.cv-row[data-conversation-id="' + data.conversation_slug + '"]');
    // A brand-new conversation has no row yet; it appears on the next page load.
    if (!row) return;

    const preview = row.querySelector('.cv-row-preview');
    const time = row.querySelector('.cv-row-time');
    if (preview) preview.textContent = data.preview;
    if (time) time.textContent = formatTime(data.at);
    rows.prepend(row);

    if (isOpenThread || !preview) return;

    row.querySelector('.cv-row-name').classList.add('cv-row-name--unread');
    preview.classList.add('cv-row-preview--unread');
    if (!row.querySelector('.cv-unread-dot')) {
      const dot = document.createElement('span');
      dot.className = 'cv-unread-dot';
      preview.parentElement.appendChild(dot);
    }
  }

  // Mirrors ConversationsHelper#conversation_timestamp for today and this week.
  function formatTime(iso) {
    const date = new Date(iso);
    const now = new Date();
    if (date.toDateString() === now.toDateString()) {
      return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLowerCase().replace(' ', '');
    }
    if (now - date < 7 * 24 * 60 * 60 * 1000) {
      return date.toLocaleDateString([], { weekday: 'short' });
    }
    return date.toLocaleDateString([], { month: 'numeric', day: 'numeric', year: '2-digit' });
  }
});
